import { render, staticRenderFns } from "./TransactionTabs.vue?vue&type=template&id=43143b54&scoped=true"
import script from "./TransactionTabs.vue?vue&type=script&lang=js"
export * from "./TransactionTabs.vue?vue&type=script&lang=js"
import style0 from "./TransactionTabs.vue?vue&type=style&index=0&id=43143b54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43143b54",
  null
  
)

export default component.exports